import axios from 'axios';

export const notifyCatalogVisit = () => {
  axios.post('/canvamanager/visit/catalog').catch(() => {});
};
